import { LifetimeParametersForm } from '@hub/bearing-hub/libs/BearingsLifetime/LifetimeParametersForm/LifetimeParametersForm';
import React from 'react';
import { useTranslation } from 'next-i18next';
import type { IbhShape } from '@igus/iglidur-bearing-hub-api';
import { Modal } from '@hub/common/Modal/Modal';
import type { UnitSystem } from '@igus/kopla-domain';
import type { LifetimeParameters } from '@hub/bearing-hub/common/types';

export type LifetimeParameterModalProps = {
  visible: boolean;
  onLifeTimeModalClose: (isOpen: boolean) => void;
  onCalculateLifeTime: () => void;
  onReset: (unitSystem: UnitSystem) => void;
  onFormUnitSystemChange?: (unitSystem: UnitSystem, lifetimeParameters: LifetimeParameters) => void;
  articleNumber?: string;
  unitSystem: UnitSystem;
  shapeKey: IbhShape;
  lifetimeIsLoading?: boolean;
};

export const LifetimeParametersModal = ({
  visible,
  onLifeTimeModalClose,
  onCalculateLifeTime,
  onReset,
  onFormUnitSystemChange,
  articleNumber,
  unitSystem,
  shapeKey,
  lifetimeIsLoading,
}: LifetimeParameterModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal closable onClose={() => onLifeTimeModalClose(false)} visible={visible}>
      <div className="p-8 overflow-auto">
        <h3 data-testId="life-Time-Modal_Header">
          {articleNumber
            ? t('LIFETIME.LIFE_TIME_MODAL_HEADER', {
                ns: 'bearing-hub/bearingHub',
                articleNumber,
              })
            : t('HEADLINES.LIFETIME', { ns: 'bearing-hub/bearingHub' })}
        </h3>
        <LifetimeParametersForm
          isEmbedded
          onCalculate={onCalculateLifeTime}
          onReset={() => onReset(unitSystem)}
          onFormUnitSystemChange={onFormUnitSystemChange}
          shapeKey={shapeKey}
          lifetimeIsLoading={lifetimeIsLoading}
          unitSystem={unitSystem}
        />
      </div>
    </Modal>
  );
};
